import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            redirect: '/mine'
        }, {
            path: '/activitylist',
            component: resolve => require(['../pages/content/activitylist.vue'], resolve)
        },
        {
            path: '/newslist',
            component: resolve => require(['../pages/content/newslist.vue'], resolve)
        },
        {
            path: '/culturelist',
            component: resolve => require(['../pages/content/culturelist.vue'], resolve)
        },
        {
            path: '/contentlist',
            component: resolve => require(['../pages/content/contentlist.vue'], resolve),
            meta: { requiresAuth: true }
        },
        {
            path: '/detail',
            component: resolve => require(['../pages/content/detail.vue'], resolve)
        },
        {
            path: '/classroom',
            component: resolve => require(['../pages/content/classroom.vue'], resolve)
        },
        {
            path: '/contentdetail',
            component: resolve => require(['../pages/content/contentdetail.vue'], resolve)
        },
        {
            path: '/mine',
            component: resolve => require(['../pages/mine/mine.vue'], resolve),
            meta: { requiresAuth: true }
        },
        {
            path: '/mine/userinfo',
            component: resolve => require(['../pages/mine/userinfo.vue'], resolve)
        },
        {
            path: '/mine/myservice',
            component: resolve => require(['../pages/mine/myservice.vue'], resolve)
        },
        {
            path: '/mine/mysubscribe',
            component: resolve => require(['../pages/mine/mysubscribe.vue'], resolve)
        },
        {
            path: '/mine/myconsultant',
            component: resolve => require(['../pages/mine/myconsultant.vue'], resolve)
        },
        {
            path: '/mine/orderconsultant',
            component: resolve => require(['../pages/mine/orderconsultant.vue'], resolve),
            meta: { requiresAuth: true }
        },
        {
            path: '/mine/editname',
            component: resolve => require(['../pages/mine/editname.vue'], resolve)
        },
        {
            path: '/register',
            component: resolve => require(['../pages/register.vue'], resolve)
        },
        {
            path: '/login',
            component: resolve => require(['../pages/login.vue'], resolve)
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        let token = localStorage.getItem('token');
        if (token && token != "") {
            next()
        } else {
            next({
                path: '/register',
                query: { redirect: to.fullPath }
            })
        }
    } else {
        next() // 确保一定要调用 next()
    }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js